import { render } from "./vimeo-player.vue?vue&type=template&id=36465a36&scoped=true&ts=true&lang=pug"
import script from "./vimeo-player.vue?vue&type=script&setup=true&lang=ts"
export * from "./vimeo-player.vue?vue&type=script&setup=true&lang=ts"

import "./vimeo-player.vue?vue&type=style&index=0&id=36465a36&lang=stylus&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36465a36"]])

export default __exports__